import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/converse")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Converse, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Converse & Bexar County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Converse, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Converse and Bexar County.",
      keywords: "awnings Converse, awning company Converse, custom awnings Converse, sail shades Converse, patio covers Converse, pergola covers Converse, metal awnings Converse, canvas awnings Converse, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Converse", "Bexar County"),
  }),
  component: () => <CityHomePage city="Converse" region="Bexar County" />,
});
